"use strict";
/*
 * Created on 04 29 2021
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DomainObject_1 = require("../../../core/model/DomainObject");
/**
 * @author Jaroslav Sevcik
 */


var SelloutImpactReportDetailRow4BOXDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SelloutImpactReportDetailRow4BOXDTO, _DomainObject_1$Domai);

  /**
   * @param hierarchy The sequence of row titles specifying the rows hierarchy. A title can be a product external ID, a sellout type
   *        or a category name. The last title relates to this row data.
   * @param productName The name of the product.
   * @param supplierNames List of suppliers of relevant release items.
   * @param values Impact values.
   */
  function SelloutImpactReportDetailRow4BOXDTO(hierarchy, productName, supplierNames, values) {
    var _this;

    _classCallCheck(this, SelloutImpactReportDetailRow4BOXDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SelloutImpactReportDetailRow4BOXDTO).call(this));
    _this.hierarchy = hierarchy;
    _this.productName = productName;
    _this.supplierNames = supplierNames;
    _this.values = values;
    return _this;
  }

  return SelloutImpactReportDetailRow4BOXDTO;
}(DomainObject_1.DomainObject);

exports.SelloutImpactReportDetailRow4BOXDTO = SelloutImpactReportDetailRow4BOXDTO;